<script>
  import moment from 'moment'
  // export let url
  // 15-03-2020
  let start = moment("2020-03-15", "YYYY-MM-DD");
  let end = moment()
  let endFormat = end.format('LL')
  let daysPassed = parseInt(moment.duration(end.diff(start)).asDays())
</script>

<div class = {"feed-container"}>
  <div class = "feed-container_inner">
    <img src = './images/radio-green.png' />
  </div>
</div>

<style lang="scss" global>
  @import "./style/global.scss";
  
  .feed-container {
    width: 50%;
    height: 100%;
    border: solid white 1px;
    border-top: 0;
    border-left: 0;
    border-bottom: 0;
    border-right: 0;
    // color: $lime;
    color: white;
    justify-content: center;
    align-items: center;
    display: flex;
    // background: black;
    // overflow: scroll;
    overflow: hidden;
    &_inner {
      @include type-sans-lg;
      text-align: center;
      // padding: $padding;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        filter: blur(1px);
      }
      & div {
        margin-bottom: .5rem;
      }
      & div:last-child {
        margin-bottom: 1rem;
      }
      & a {
        color: $lime;
        text-decoration: none;
      }
      & div a {
        text-decoration: none;
        color: white;
        &:hover {
          color: $lime;
        }
      }
    }
  }

</style>